// removed by extract-text-webpack-plugin
module.exports = {"summarySection":"summarySection__1dnVO","summaryList":"summaryList__3GdaZ","entryCard":"entryCard__15aEw","legal":"legal__pp5Bw","summaryRow":"summaryRow__154UQ"};


//////////////////
// WEBPACK FOOTER
// ./components/signup-flow/step-payment/summary-section.sass
// module id = dga2
// module chunks = 1 5